// src/components/admin/AdminContent.jsx
import React from "react";
import { motion, AnimatePresence } from "framer-motion";

import DataSecurity from "../admin/DataSecurity"; 
import DataCleaning from "./DataCleaningService"; 
import DataAkun from "../admin/DataAkun";
import KelolaUtama from "../admin/KelolaUtama";
import Catatan from "../admin/Catatan";
import DataGaleri from "../admin/DataGaleri";

const variants = {
  hidden: { opacity: 0, y: 10, scale: 0.995 },
  enter: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.36, ease: [0.16, 1, 0.3, 1] } },
  exit: { opacity: 0, y: -8, scale: 0.995, transition: { duration: 0.28 } },
};

export default function AdminContent({ activeTab }) {
  const render = () => {
    switch (activeTab) {
      case "security":
        return <DataSecurity />;
      case "cleaning":
        return <DataCleaning />;
      case "bertugas":
        return <DataAkun />;
      case "utama":
        return <KelolaUtama />;
      case "catatan":
        return <Catatan />;
      case "galeri":
        return <DataGaleri/>;
      default:
        return <DataSecurity />;
    }
  };

  return (
    <section className="relative w-full min-h-[70vh]">
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={activeTab}
          variants={variants}
          initial="hidden"
          animate="enter"
          exit="exit"
          className="w-full h-full"
        >
          {render()}
        </motion.div>
      </AnimatePresence>
    </section>
  );
}
